<template>
  <div>
    <div class="columns is-mobile is-vcentered">
      <div class="column">
        <h1 class="title font-16 has-text-darkblue font-w-600">Jadwal Minggu Ini</h1>
      </div>
    </div>

    <div class="columns is-mobile is-vecentered">
      <div class="column">
        <div class="box is-boxed-3" v-if="isEmpty(week_schedules)">
          <p class="has-text-grey">Tidak ada jadwal</p>
        </div>
        <div class="box is-boxed-3" style="padding: 0;" v-else>
          <div class="colums" style="padding: 1.5rem 1rem 0rem 1rem;">
            <div class="column is-narrow">
              <div class="columns is-mobile has-text-centered">
                <div v-for="(schedule, schedule_index) in week_schedules" :key="schedule_index" class="column is-narrow week-schedule-grid">
                  <p class="font-12 has-text-primary2 font-w-600">{{ schedule.hari.substring(0, 3) }}</p>
                  <p class="font-16 schedule-date">
                    <button class="button week-schedule-button"
                      :class="selected_date === schedule.tanggal ? 'is-success has-background-lightprimary' : 'is-white'"
                      @click="() => { selected_date = schedule.tanggal }">
                      <span class="icon" :class="isToday(schedule.tanggal) ? 'has-text-primary font-w-600' : 'has-text-darkblue font-w-400'">{{ getDateOfDay(schedule.tanggal) }}</span>
                    </button>
                  </p>
                  <span v-if="schedule.perkuliahan.length > 0" class="font-w-300 has-text-secondary schedule-exist"><i class="fas fa-circle"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column" style="padding: 0px; margin-bottom: -10px;">
              <div class="is-divider schedule-divider"></div>
            </div>
          </div>
          <div v-for="(schedule, schedule_index) in week_schedules" :key="schedule_index">
            <div v-if="selected_date === schedule.tanggal">
              <div v-if="schedule.perkuliahan.length === 0" class="columns" style="padding: 1rem 1rem 1.5rem 1rem;">
                <div class="column has-text-centered">
                  <div>
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M50 14H14C10.691 14 8 16.691 8 20V26.081V50C8 53.309 10.691 56 14 56H50C53.309 56 56 53.309 56 50V26.081V20C56 16.691 53.309 14 50 14ZM52.001 50C52.001 51.104 51.104 52.001 50 52.001H14C12.896 52.001 11.999 51.104 11.999 50V28.079H51.998V50H52.001Z" fill="#CCD0EB"/>
                      <path d="M20 8H17.999C16.895 8 15.998 8.894 15.998 10.001V18.002C15.998 19.106 16.892 20.003 17.999 20.003H20C21.104 20.003 22.001 19.109 22.001 18.002V10.001C22.001 8.894 21.104 8 20 8Z" fill="#E2E7FF"/>
                      <path d="M46.001 8H44C42.896 8 41.999 8.894 41.999 10.001V18.002C41.999 19.106 42.896 20 44 20H46.001C47.105 20 48.002 19.106 48.002 17.999V10.001C47.999 8.894 47.105 8 46.001 8Z" fill="#E2E7FF"/>
                    </svg>
                  </div>
                  <p class="font-14 has-text-darkblue font-w-500">Tidak Ada Jadwal Kelas di Tanggal Ini</p>
                </div>
              </div>
              <div v-else>
                <div v-for="(section, section_index) in schedule.perkuliahan" :key="section_index" style="margin-bottom: 15px;">
                  <div class="colums" style="padding: 1.5rem 1rem 0rem 1rem;">
                    <div class="column is-narrow has-text-left">
                      <div class="columns">
                        <div class="column" style="padding: 0;">
                          <span class="tag is-normal is-rounded font-12 font-w-600"
                            :class="(!isEmpty(section.started_at) && isPast(section.started_at)) ? 'has-background-grey' : 'has-background-lightyellow'">
                            <a href="#" class="button is-text font-12 font-w-600"
                              :class="(!isEmpty(section.started_at) && isPast(section.started_at)) ? '' : 'has-text-secondary'"
                              style="background: none; cursor: auto;">
                              <span>Sesi ke {{ section.meet }}&nbsp;</span>
                              <span v-if="!isEmpty(section.section)" class="icon">
                                <svg v-if="!isEmpty(section.started_at) && isPast(section.started_at)" width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.7252 5.56445C19.6156 2.47316 16.9789 0 13.7399 0C11.6788 0 9.86055 1.00184 8.78269 2.52751C8.23423 2.21779 7.59601 2.03969 6.91485 2.03969C5.00411 2.03969 3.43225 3.43375 3.23696 5.22264C1.38134 5.64236 0 7.24399 0 9.15728C0 11.3901 1.88079 13.2 4.20117 13.2H17.7988C20.1192 13.2 22 11.3901 22 9.15728C22.0007 7.59235 21.0766 6.23626 19.7252 5.56445Z" fill="white"/>
                                  <path d="M19.7252 5.56445C19.6156 2.47316 16.9789 0 13.7399 0C11.6788 0 9.86055 1.00184 8.78269 2.52751C8.23423 2.21779 7.59601 2.03969 6.91485 2.03969C5.00411 2.03969 3.43225 3.43375 3.23696 5.22264C1.38134 5.64236 0 7.24399 0 9.15728C0 11.3901 1.88079 13.2 4.20117 13.2H17.7988C20.1192 13.2 22 11.3901 22 9.15728C22.0007 7.59235 21.0766 6.23626 19.7252 5.56445ZM17.7552 3.38202C17.7552 3.38202 15.2621 1.89301 12.1109 1.49293C12.1109 1.49293 15.8506 0.572945 17.7552 3.38202ZM17.0517 7.07243C17.0544 7.11958 17.0891 7.15952 17.1374 7.16934L17.3069 7.20405C17.4552 7.23482 17.5607 7.36054 17.5607 7.50589V7.53669L17.4219 7.54519C17.6539 9.80687 18.0989 10.0164 18.0989 10.0164C17.7178 10.3052 16.4134 10.5717 16.4134 10.5717L16.5509 7.70037H16.408V7.55436C16.408 7.51637 16.4256 7.48103 16.4563 7.45749L16.719 7.25578C16.7509 7.23089 16.7659 7.19095 16.757 7.15166L16.6931 6.87207L15.5826 7.73901L15.19 6.87272L15.4438 8.75527C15.4438 8.75527 8.65685 7.57203 5.71315 11.8708C5.71315 11.8708 5.78256 9.95485 6.11123 8.75527L5.66076 9.82124L2.82119 8.97131L10.1218 3.89537C10.1218 3.89537 14.6986 5.33919 18.6977 5.3058L17.0258 6.6108L17.0517 7.07243Z" fill="#828282"/>
                                </svg>
                                <svg v-else width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.7252 5.56445C19.6156 2.47316 16.9789 0 13.7399 0C11.6788 0 9.86055 1.00184 8.78269 2.52751C8.23423 2.21779 7.59601 2.03969 6.91485 2.03969C5.00411 2.03969 3.43225 3.43375 3.23696 5.22264C1.38134 5.64236 0 7.24399 0 9.15728C0 11.3901 1.88079 13.2 4.20117 13.2H17.7988C20.1192 13.2 22 11.3901 22 9.15728C22.0007 7.59235 21.0766 6.23626 19.7252 5.56445Z" fill="white"/>
                                  <path d="M19.7252 5.56445C19.6156 2.47316 16.9789 0 13.7399 0C11.6788 0 9.86055 1.00184 8.78269 2.52751C8.23423 2.21779 7.59601 2.03969 6.91485 2.03969C5.00411 2.03969 3.43225 3.43375 3.23696 5.22264C1.38134 5.64236 0 7.24399 0 9.15728C0 11.3901 1.88079 13.2 4.20117 13.2H17.7988C20.1192 13.2 22 11.3901 22 9.15728C22.0007 7.59235 21.0766 6.23626 19.7252 5.56445ZM17.7552 3.38202C17.7552 3.38202 15.2621 1.89301 12.1109 1.49293C12.1109 1.49293 15.8506 0.572945 17.7552 3.38202ZM17.0517 7.07243C17.0544 7.11958 17.0891 7.15952 17.1374 7.16934L17.3069 7.20405C17.4552 7.23482 17.5607 7.36054 17.5607 7.50589V7.53669L17.4219 7.54519C17.6539 9.80687 18.0989 10.0164 18.0989 10.0164C17.7178 10.3052 16.4134 10.5717 16.4134 10.5717L16.5509 7.70037H16.408V7.55436C16.408 7.51637 16.4256 7.48103 16.4563 7.45749L16.719 7.25578C16.7509 7.23089 16.7659 7.19095 16.757 7.15166L16.6931 6.87207L15.5826 7.73901L15.19 6.87272L15.4438 8.75527C15.4438 8.75527 8.65685 7.57203 5.71315 11.8708C5.71315 11.8708 5.78256 9.95485 6.11123 8.75527L5.66076 9.82124L2.82119 8.97131L10.1218 3.89537C10.1218 3.89537 14.6986 5.33919 18.6977 5.3058L17.0258 6.6108L17.0517 7.07243Z" fill="#FFBB47"/>
                                </svg>
                              </span>
                              <span v-else class="icon">
                                <svg v-if="!isEmpty(section.started_at) && isPast(section.started_at)" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M17.271 8.80366C17.1797 6.22759 14.9824 4.16663 12.2832 4.16663C10.5657 4.16663 9.05047 5.00149 8.15225 6.27288C7.6952 6.01479 7.16335 5.86636 6.59572 5.86636C5.00344 5.86636 3.69355 7.02808 3.53081 8.51883C1.98446 8.86859 0.833344 10.2033 0.833344 11.7977C0.833344 13.6584 2.40067 15.1666 4.33432 15.1666H15.6657C17.5994 15.1666 19.1667 13.6584 19.1667 11.7977C19.1672 10.4936 18.3972 9.36351 17.271 8.80366Z" fill="white"/>
                                  <path d="M17.271 8.80366C17.1797 6.22759 14.9824 4.16663 12.2832 4.16663C10.5657 4.16663 9.05046 5.00149 8.15225 6.27288C7.6952 6.01478 7.16335 5.86636 6.59572 5.86636C5.00344 5.86636 3.69355 7.02808 3.53081 8.51882C1.98446 8.86859 0.833344 10.2033 0.833344 11.7977C0.833344 13.6584 2.40067 15.1666 4.33432 15.1666H15.6657C17.5994 15.1666 19.1667 13.6584 19.1667 11.7977C19.1672 10.4936 18.3972 9.36351 17.271 8.80366ZM15.6294 6.98497C15.6294 6.98497 13.5517 5.74414 10.9257 5.41074C10.9257 5.41074 14.0422 4.64408 15.6294 6.98497ZM15.0431 10.0603C15.0453 10.0996 15.0742 10.1329 15.1145 10.1411L15.2557 10.17C15.3793 10.1956 15.4673 10.3004 15.4673 10.4215V10.4472L15.3516 10.4543C15.5449 12.339 15.9157 12.5136 15.9157 12.5136C15.5982 12.7543 14.5112 12.9763 14.5112 12.9763L14.6258 10.5836H14.5066V10.4619C14.5066 10.4303 14.5214 10.4008 14.5469 10.3812L14.7658 10.2131C14.7925 10.1924 14.8049 10.1591 14.7975 10.1263L14.7442 9.89335L13.8188 10.6158L13.4917 9.89389L13.7032 11.4627C13.7032 11.4627 8.04739 10.4767 5.5943 14.0589C5.5943 14.0589 5.65214 12.4623 5.92603 11.4627L5.55064 12.351L3.18434 11.6427L9.2682 7.41277C9.2682 7.41277 13.0822 8.61595 16.4148 8.58812L15.0215 9.67563L15.0431 10.0603Z" fill="#828282"/>
                                  <ellipse cx="15" cy="14.5834" rx="5" ry="5" fill="white"/>
                                  <path d="M15 9.58337C12.2432 9.58337 10 11.8266 10 14.5834C10 17.3402 12.2432 19.5834 15 19.5834C17.7568 19.5834 20 17.3402 20 14.5834C20 11.8266 17.7568 9.58337 15 9.58337ZM15 17.5002C14.7701 17.5002 14.5831 17.3139 14.5831 17.0834C14.5831 16.8534 14.7694 16.6665 15 16.6665C15.2299 16.6665 15.4169 16.8528 15.4169 17.0834C15.4169 17.3133 15.2299 17.5002 15 17.5002ZM15.4169 15.4165C15.4169 15.6471 15.2299 15.8334 15 15.8334C14.7701 15.8334 14.5831 15.6465 14.5831 15.4165V12.0834C14.5831 11.8534 14.7701 11.6665 15 11.6665C15.2299 11.6665 15.4169 11.8534 15.4169 12.0834V15.4165Z" fill="#333333"/>
                                </svg>
                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M17.271 8.80366C17.1797 6.22759 14.9824 4.16663 12.2832 4.16663C10.5657 4.16663 9.05047 5.00149 8.15225 6.27288C7.6952 6.01479 7.16335 5.86636 6.59572 5.86636C5.00344 5.86636 3.69355 7.02808 3.53081 8.51883C1.98446 8.86859 0.833344 10.2033 0.833344 11.7977C0.833344 13.6584 2.40067 15.1666 4.33432 15.1666H15.6657C17.5994 15.1666 19.1667 13.6584 19.1667 11.7977C19.1672 10.4936 18.3972 9.36351 17.271 8.80366Z" fill="white"/>
                                  <path d="M17.271 8.80366C17.1797 6.22759 14.9824 4.16663 12.2832 4.16663C10.5657 4.16663 9.05046 5.00149 8.15225 6.27288C7.6952 6.01478 7.16335 5.86636 6.59572 5.86636C5.00344 5.86636 3.69355 7.02808 3.53081 8.51882C1.98446 8.86859 0.833344 10.2033 0.833344 11.7977C0.833344 13.6584 2.40067 15.1666 4.33432 15.1666H15.6657C17.5994 15.1666 19.1667 13.6584 19.1667 11.7977C19.1672 10.4936 18.3972 9.36351 17.271 8.80366ZM15.6294 6.98497C15.6294 6.98497 13.5517 5.74414 10.9257 5.41074C10.9257 5.41074 14.0422 4.64408 15.6294 6.98497ZM15.0431 10.0603C15.0453 10.0996 15.0742 10.1329 15.1145 10.1411L15.2557 10.17C15.3793 10.1956 15.4673 10.3004 15.4673 10.4215V10.4472L15.3516 10.4543C15.5449 12.339 15.9157 12.5136 15.9157 12.5136C15.5982 12.7543 14.5112 12.9763 14.5112 12.9763L14.6258 10.5836H14.5066V10.4619C14.5066 10.4303 14.5214 10.4008 14.5469 10.3812L14.7658 10.2131C14.7925 10.1924 14.8049 10.1591 14.7975 10.1263L14.7442 9.89335L13.8188 10.6158L13.4917 9.89389L13.7032 11.4627C13.7032 11.4627 8.04739 10.4767 5.5943 14.0589C5.5943 14.0589 5.65214 12.4623 5.92603 11.4627L5.55064 12.351L3.18434 11.6427L9.2682 7.41277C9.2682 7.41277 13.0822 8.61595 16.4148 8.58812L15.0215 9.67563L15.0431 10.0603Z" fill="#FFBB47"/>
                                  <ellipse cx="15" cy="14.5834" rx="5" ry="5" fill="white"/>
                                  <path d="M15 9.58337C12.2432 9.58337 10 11.8266 10 14.5834C10 17.3402 12.2432 19.5834 15 19.5834C17.7568 19.5834 20 17.3402 20 14.5834C20 11.8266 17.7568 9.58337 15 9.58337ZM15 17.5002C14.7701 17.5002 14.5831 17.3139 14.5831 17.0834C14.5831 16.8534 14.7694 16.6665 15 16.6665C15.2299 16.6665 15.4169 16.8528 15.4169 17.0834C15.4169 17.3133 15.2299 17.5002 15 17.5002ZM15.4169 15.4165C15.4169 15.6471 15.2299 15.8334 15 15.8334C14.7701 15.8334 14.5831 15.6465 14.5831 15.4165V12.0834C14.5831 11.8534 14.7701 11.6665 15 11.6665C15.2299 11.6665 15.4169 11.8534 15.4169 12.0834V15.4165Z" fill="#EB5757"/>
                                </svg>
                              </span>
                            </a>
                          </span>
                          <span v-if="section.progress === 'S'"
                            class="tag is-normal is-rounded font-12 font-w-600 has-background-greystroke has-text-darkblue">
                            {{ section.progress_label }}
                          </span>
                          <span v-else-if="section.progress === 'B'"
                            class="tag is-normal is-rounded font-12 font-w-600 has-background-lightprimary">
                            {{ section.progress_label }}
                          </span>
                          <span v-else class="tag is-normal is-white font-12 font-w-600 has-text-grey2">{{ section.progress_label }}</span>
                        </div>
                      </div>
                      <div class="columns" style="margin-bottom: 0px;">
                        <div class="column font-16 has-text-darkblue font-w-600" style="margin-top: 0.75rem; margin-bottom: 0.75rem; padding: 0;">{{ section.nama_mata_kuliah }}</div>
                      </div>
                      <div class="columns" style="margin-bottom: 10px;">
                        <div class="column" style="margin-bottom: 0px; padding: 5px 5px 5px 0px;">
                          <p class="has-text-darkblue">
                            <a href="" @click.prevent="() => {}" class="button is-text" style="background: none; cursor: auto; padding: 5px;">
                              <span class="icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3.83334 4.80583V2.30583C3.83334 2.16166 3.85001 2.02249 3.88918 1.88916H2.30584C1.77251 1.88916 1.33334 2.32749 1.33334 2.86083V5.36083C1.33334 5.89416 1.77251 6.33333 2.30584 6.33333H2.51168L3.22251 7.27749C3.30001 7.37749 3.41668 7.43833 3.53918 7.44416H3.55584C3.67834 7.44416 3.78918 7.39416 3.86668 7.29999L4.70001 6.34999C4.18334 6.02749 3.83334 5.45583 3.83334 4.80583Z" fill="#E2E7FF"/>
                                  <path d="M13.6942 1.88916H12.1108C12.15 2.02249 12.1667 2.16083 12.1667 2.30583V4.80583C12.1667 5.45583 11.8167 6.02833 11.3 6.34999L12.1333 7.29999C12.2108 7.39416 12.3225 7.44416 12.4442 7.44416H12.4608C12.5833 7.43833 12.7 7.37749 12.7775 7.27749L13.4833 6.33333H13.6942C14.2275 6.33333 14.6667 5.89416 14.6667 5.36083V2.86083C14.6667 2.32749 14.2275 1.88916 13.6942 1.88916Z" fill="#E2E7FF"/>
                                  <path d="M8.00002 6.8892C7.99502 6.8892 7.99002 6.8892 7.98418 6.8892C7.85835 6.8842 7.74169 6.82337 7.66669 6.72254L6.95835 5.77837H5.63919C5.10335 5.77837 4.66669 5.34254 4.66669 4.80587V2.30587C4.66669 1.76921 5.10252 1.33337 5.63919 1.33337H10.3617C10.8975 1.33337 11.3333 1.76921 11.3333 2.30587V4.80587C11.3333 5.34171 10.8975 5.77837 10.3609 5.77837H9.16085L8.31335 6.74671C8.23418 6.83671 8.12002 6.8892 8.00002 6.8892Z" fill="#E2E7FF"/>
                                  <path d="M3.55584 10.7776C4.16934 10.7776 4.66667 10.2802 4.66667 9.66674C4.66667 9.05325 4.16934 8.55591 3.55584 8.55591C2.94234 8.55591 2.44501 9.05325 2.44501 9.66674C2.44501 10.2802 2.94234 10.7776 3.55584 10.7776Z" fill="#CCD0EB"/>
                                  <path d="M5.03918 11.5559C4.47834 11.9784 4.11168 12.6559 4.11168 13.4167V13.5559H1.75001C1.52251 13.5559 1.33334 13.3667 1.33334 13.1392V12.8617C1.33334 12.0167 2.01668 11.3334 2.86084 11.3334H4.25001C4.53918 11.3334 4.81084 11.4167 5.03918 11.5559Z" fill="#CCD0EB"/>
                                  <path d="M12.4442 10.7776C13.0577 10.7776 13.555 10.2802 13.555 9.66674C13.555 9.05325 13.0577 8.55591 12.4442 8.55591C11.8307 8.55591 11.3333 9.05325 11.3333 9.66674C11.3333 10.2802 11.8307 10.7776 12.4442 10.7776Z" fill="#CCD0EB"/>
                                  <path d="M14.6667 12.8609V13.1384C14.6667 13.3659 14.4776 13.555 14.2501 13.555H11.8892V13.4167C11.8892 12.6559 11.5226 11.9775 10.9617 11.5559C11.1892 11.4167 11.4609 11.3334 11.7501 11.3334H13.1392C13.9834 11.3334 14.6667 12.0167 14.6667 12.8609Z" fill="#CCD0EB"/>
                                  <path d="M8.00001 11.0559C8.92049 11.0559 9.66668 10.3097 9.66668 9.3892C9.66668 8.46873 8.92049 7.72253 8.00001 7.72253C7.07954 7.72253 6.33334 8.46873 6.33334 9.3892C6.33334 10.3097 7.07954 11.0559 8.00001 11.0559Z" fill="#CCD0EB"/>
                                  <path d="M9.52752 11.8892H6.47169C5.62918 11.8892 4.94418 12.5742 4.94418 13.4167V14.25C4.94418 14.48 5.13085 14.6667 5.36085 14.6667H10.6384C10.8684 14.6667 11.055 14.48 11.055 14.25V13.4167C11.0559 12.5742 10.37 11.8892 9.52752 11.8892Z" fill="#CCD0EB"/>
                                </svg>
                              </span>
                              <span class="font-12 has-text-darkblue font-w-400" style="background: none;">&nbsp;{{ section.nama_kelas_kuliah }}</span>
                            </a>
                          </p>
                          <p class="has-text-darkblue">
                            <a href="" @click.prevent="() => {}" class="button is-text" style="background: none; cursor: auto; padding: 5px;">
                              <span class="icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99334 1.33337C4.31334 1.33337 1.33334 4.32004 1.33334 8.00004C1.33334 11.68 4.31334 14.6667 7.99334 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004C14.6667 4.32004 11.68 1.33337 7.99334 1.33337ZM8.00001 13.3334C5.05334 13.3334 2.66668 10.9467 2.66668 8.00004C2.66668 5.05337 5.05334 2.66671 8.00001 2.66671C10.9467 2.66671 13.3333 5.05337 13.3333 8.00004C13.3333 10.9467 10.9467 13.3334 8.00001 13.3334ZM7.33334 4.66671H8.33334V8.16671L11.3333 9.94671L10.8333 10.7667L7.33334 8.66671V4.66671Z" fill="#CCD0EB"/>
                                </svg>
                              </span>
                              <span class="font-14 has-text-darkblue font-w-400" style="background: none;">&nbsp;{{ section.waktu_mulai }} - {{ section.waktu_selesai }}</span>
                            </a>
                          </p>
                        </div>
                      </div>
                      <div v-if="!isEmpty(account) && ['ADMIN', 'LECTURER'].indexOf(account.type) > -1" class="columns is-vcentered">
                        <div class="column is-narrow" v-if="section.progress === 'B' || section.progress === 'S'" style="margin-bottom: 0px; padding: 0;">
                          <button v-if="section.progress === 'B'" class="button is-text is-primary is-outlined"
                            style="margin-right: 20px;"
                            @click="setModalSectionOperation(section, 'confirm_finish')">
                            <span class="icon"><i class="fas fa-stop-circle"></i></span>
                            <span class="font-w-500">Selesaikan Sesi</span>
                          </button>
                          <button v-if="section.progress === 'S' && !isEmpty(section.started_at_timestamp) && isDateSameOrAfter(getDateStringFromTimestamp(section.started_at_timestamp), 'day')"
                            class="button is-text is-primary"
                            style="margin-right: 20px;"
                            @click="setModalSectionOperation(section, 'confirm_start')">
                            <span class="icon">
                              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.87596 1.16669C2.8399 1.16669 2 2.00658 2 3.04265V13.9574C2 14.9934 2.8399 15.8334 3.87596 15.8334H12.062C13.0981 15.8334 13.938 14.9934 13.938 13.9574V5.77138C13.938 4.73527 13.0981 3.89533 12.062 3.89533H3.87596C3.40507 3.89533 3.02327 3.51363 3.02327 3.04265C3.02327 2.57172 3.40507 2.18994 3.87596 2.18994H13.4263C13.709 2.18994 13.938 1.96088 13.938 1.67832C13.938 1.39575 13.709 1.16669 13.4263 1.16669H3.87596Z" fill="white"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.86763 7.37914C6.7096 7.28436 6.5127 7.28189 6.35228 7.37264C6.19196 7.46348 6.09277 7.63361 6.09277 7.81786V11.9109C6.09277 12.0952 6.19196 12.2653 6.35228 12.3561C6.5127 12.4469 6.7096 12.4445 6.86763 12.3496L10.2784 10.3031C10.4325 10.2106 10.5269 10.0441 10.5269 9.86441C10.5269 9.68465 10.4325 9.51819 10.2784 9.42569L6.86763 7.37914Z" fill="#279B24"/>
                              </svg>
                            </span>
                            <span class="font-w-600 font-12">Mulai Sesi</span>
                          </button>
                        </div>
                        <div class="column is-narrow" style="padding: 0;">
                          <button class="button is-text is-white has-text-primary font-14 font-w-600" style="padding: 0;"
                            @click="goToPresence(section)">
                            <span>Presensi</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="section_index < schedule.perkuliahan.length - 1" class="columns">
                    <div class="column" style="padding: 0px;">
                      <div class="is-divider schedule-divider"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-if="section_operation.modal_show" :active.sync="section_operation.modal_show" :can-cancel="false" :width="430">
      <div v-if="section_operation.sync_fail" class="card" style="border-radius: 8px;">
        <div class="card-content">
          <div class="columns">
            <div class="column has-text-centered has-text-darkblue">
              <p class="has-text-right" style="cursor: pointer;" @click="closeSectionModal">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7.99999 7.99999M7.99999 7.99999L15 15M7.99999 7.99999L15 1M7.99999 7.99999L1 15" stroke="#394693" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </p>
              <p>
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M40 0C17.9456 0 0 17.9456 0 40C0 62.0544 17.9456 80 40 80C62.0544 80 80 62.0544 80 40C80 17.9456 62.0544 0 40 0ZM40 63.335C38.1604 63.335 36.665 61.8445 36.665 60C36.665 58.1604 38.1555 56.665 40 56.665C41.8396 56.665 43.335 58.1555 43.335 60C43.335 61.8396 41.8396 63.335 40 63.335ZM43.335 46.665C43.335 48.5095 41.8396 50 40 50C38.1604 50 36.665 48.5046 36.665 46.665V20C36.665 18.1604 38.1604 16.665 40 16.665C41.8396 16.665 43.335 18.1604 43.335 20V46.665Z" fill="#EB5757"/>
                </svg>
              </p>
              <p class="font-18 font-w-600">Terjadi Kendala di Sistem</p>
              <p class="font-16" style="margin-top: 10px;">Ada kendala saat mempersiapkan kelas. Silakan coba lagi.</p>
              <p style="margin-top: 10px;">
                <button class="button is-text is-normal is-primary is-outlined is-fullwidth"
                  :class="{'is-loading': section_operation.loading}"
                  :disabled="section_operation.loading"
                  @click="sectionOperation">
                  <span class="font-w-600">Coba Lagi</span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="card" style="border-radius: 8px;">
        <div v-if="section_operation.step === 'confirm_start'" class="card-content">
          <div class="columns">
            <div class="column has-text-centered has-text-darkblue">
              <p class="font-18 font-w-600">Mulai Sesi Perkuliahan?</p>
              <p class="font-14">Status dimulainya perkuliahan juga akan terkirim ke sistem akademik Anda.</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <button class="button is-text is-medium is-fullwidth has-background-greystroke has-text-primary2"
                :disabled="section_operation.loading"
                @click="closeSectionModal">
                Tidak
              </button>
            </div>
            <div class="column is-6">
              <button class="button is-primary is-medium font-w-500 is-fullwidth"
                :class="{'is-loading': section_operation.loading}"
                :disabled="section_operation.loading"
                @click="sectionOperation">
                Ya, Mulai Sesi
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="section_operation.step === 'confirm_finish'" class="card-content">
          <div class="columns">
            <div class="column has-text-centered has-text-darkblue">
              <p class="font-18 font-w-600">Anda akan menyelesaikan Sesi</p>
              <p class="font-14">Selanjutnya, silakan mengisi Rencana dan Realisasi sesi perkuliahan ini.</p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6">
              <button class="button is-text is-medium is-fullwidth has-background-greystroke has-text-primary2" :disabled="section_operation.loading" @click="closeSectionModal">Batal</button>
            </div>
            <div class="column is-6">
              <button class="button is-primary is-medium font-w-500 is-fullwidth"
                :class="{'is-loading': section_operation.loading}"
                :disabled="section_operation.loading"
                @click="sectionOperation">
                Lanjutkan
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="section_operation.step === 'start_success'" class="card-content">
          <div class="columns">
            <div class="column has-text-centered has-text-darkblue">
              <p class="has-text-right" style="cursor: pointer;" @click="closeSectionModal">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7.99999 7.99999M7.99999 7.99999L15 15M7.99999 7.99999L15 1M7.99999 7.99999L1 15" stroke="#394693" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </p>
              <p>
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M40 0C17.9456 0 0 17.9456 0 40C0 62.0544 17.9456 80 40 80C62.0544 80 80 62.0544 80 40C80 17.9456 62.0544 0 40 0ZM60.2747 31.5247L38.6096 53.1897C37.9602 53.8403 37.1045 54.165 36.2549 54.165C35.4004 54.165 34.5496 53.8403 33.9001 53.1897L23.0652 42.3547C21.7651 41.0547 21.7651 38.9453 23.0652 37.6404C24.3652 36.3354 26.4746 36.3403 27.7795 37.6404L36.2549 46.1145L55.5652 26.8054C56.8652 25.5054 58.9746 25.5054 60.2795 26.8054C61.5845 28.1055 61.5747 30.2197 60.2747 31.5247Z" fill="#279B24"/>
                </svg>
              </p>
              <p class="font-18 font-w-600">Sesi berhasil dimulai.</p>
              <p class="font-16" style="margin-top: 10px;">Silahkan melanjutkan kegiatan mengajar Anda. Tetap semangat!</p>
            </div>
          </div>
        </div>
        <div v-else-if="section_operation.step === 'preparing_class'" class="card-content">
          <div class="columns">
            <div class="column has-text-centered has-text-darkblue">
              <p><spinner-loading></spinner-loading></p>
              <p class="font-18 font-w-600">Mempersiapkan kelas...</p>
              <p class="font-16" style="margin-top: 10px;">Silakan tunggu sebentar. Kelas perkuliahan Anda sedang dipersiapkan.</p>
            </div>
          </div>
        </div>
        <div v-else-if="section_operation.step === 'confirm_sync_before_presence'" class="card-content">
          <div class="columns">
            <div class="column has-text-centered has-text-darkblue">
              <p class="has-text-right" style="cursor: pointer;" @click="closeSectionModal">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7.99999 7.99999M7.99999 7.99999L15 15M7.99999 7.99999L15 1M7.99999 7.99999L1 15" stroke="#394693" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </p>
              <p>
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M40 0C17.9456 0 0 17.9456 0 40C0 62.0544 17.9456 80 40 80C62.0544 80 80 62.0544 80 40C80 17.9456 62.0544 0 40 0ZM40 63.335C38.1604 63.335 36.665 61.8445 36.665 60C36.665 58.1604 38.1555 56.665 40 56.665C41.8396 56.665 43.335 58.1555 43.335 60C43.335 61.8396 41.8396 63.335 40 63.335ZM43.335 46.665C43.335 48.5095 41.8396 50 40 50C38.1604 50 36.665 48.5046 36.665 46.665V20C36.665 18.1604 38.1604 16.665 40 16.665C41.8396 16.665 43.335 18.1604 43.335 20V46.665Z" fill="#FFA000"/>
                </svg>
              </p>
              <p class="font-18 font-w-600">Belum Bisa Akses Presensi</p>
              <p class="font-16" style="margin-top: 10px;">Lakukan sinkronisasi kelas, untuk bisa mengakses presensi kelas ini.</p>
              <p style="margin-top: 10px;">
                <button class="button is-text is-normal is-primary is-outlined is-fullwidth"
                  :class="{'is-loading': section_operation.loading}"
                  :disabled="section_operation.loading"
                  @click="setSyncBeforePresence">
                  <span class="font-w-600">Sinkronisasi Kelas Ini</span>
                </button>
              </p>
            </div>
          </div>
        </div>
        <div v-else-if="section_operation.step === 'cannot_presence'" class="card-content">
          <div class="columns">
            <div class="column has-text-centered has-text-darkblue">
              <p class="has-text-right" style="cursor: pointer;" @click="closeSectionModal">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7.99999 7.99999M7.99999 7.99999L15 15M7.99999 7.99999L15 1M7.99999 7.99999L1 15" stroke="#394693" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </p>
              <p>
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M40 0C17.9456 0 0 17.9456 0 40C0 62.0544 17.9456 80 40 80C62.0544 80 80 62.0544 80 40C80 17.9456 62.0544 0 40 0ZM40 63.335C38.1604 63.335 36.665 61.8445 36.665 60C36.665 58.1604 38.1555 56.665 40 56.665C41.8396 56.665 43.335 58.1555 43.335 60C43.335 61.8396 41.8396 63.335 40 63.335ZM43.335 46.665C43.335 48.5095 41.8396 50 40 50C38.1604 50 36.665 48.5046 36.665 46.665V20C36.665 18.1604 38.1604 16.665 40 16.665C41.8396 16.665 43.335 18.1604 43.335 20V46.665Z" fill="#EB5757"/>
                </svg>
              </p>
              <p class="font-18 font-w-600">Presensi belum bisa dilakukan.</p>
              <p class="font-16" style="margin-top: 10px;">Sesi perkuliahan belum dimulai. Anda bisa melakukan perkuliahan sesuai dengan jadwal. Pastikan kembali jadwal kelas Anda.</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { GROUP, SECTION } from '~/consts';
import TRACKER_MIXIN from '~/mixins/tracker';

export default {
  mixins: [TRACKER_MIXIN],

  props: {
    open: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    this.getWeekSchedules()
    this.selected_date = moment().format('YYYY-MM-DD')
  },

  data() {
    return {
      selected_date: null,
      section_operation: {
        modal_show: false,
        // confirm_start, confirm_finish, start_success, preparing_class
        step: 'preparing_class',
        section: {},
        loading: false,
        sync_fail: false,
      },
    }
  },

  computed: {
    ...mapState({
      account: state => state.auth.active_pt,
      week_schedules: state => state.universities.week_schedules
    }),
  },

  methods: {
    ...mapActions({
      getWeekSchedules: 'universities/getWeekSchedules'
    }),
    getDateStringFromTimestamp(timestamp) {
      return this.dateFormat(this.momentCreateFromUnixTimestamp(timestamp))
    },
    isToday(day) {
      return moment().format('YYYY-MM-DD') === day
    },
    getDateOfDay(string_day) {
      return moment(string_day).format('D')
    },
    setModalSectionOperation(section, step) {
      const vm = this

      vm.section_operation.section = section
      vm.section_operation.step = step

      const show_modal_steps = ['confirm_start', 'confirm_finish', 'start_success', 'cannot_presence', 'confirm_sync_before_presence']

    if (show_modal_steps.indexOf(step) !== -1) {
        vm.section_operation.modal_show = true
      } else {
        vm.section_operation.modal_show = false
      }
    },
    closeSectionModal() {
      const vm = this
      vm.section_operation.modal_show = false
      vm.section_operation.section = {}
      vm.section_operation.step = ''
      vm.section_operation.sync_fail = false
    },
    goToPresence(section) {
      const vm = this

      if (!vm.isEmpty(section.progress) && section.progress === 'S') {
        vm.setModalSectionOperation(section, 'cannot_presence')
      } else {
        if (vm.isEmpty(section.section)) {
          this.setModalSectionOperation(section, 'confirm_sync_before_presence')
        } else {
          vm.section_operation.section = section
          vm.section_operation.step = 'presence'
          vm.sectionOperation()
        }
      }
    },
    setSyncBeforePresence() {
      const vm = this
      vm.section_operation.step = 'presence'
      vm.sectionOperation()
    },
    async sectionOperation() {
      const vm = this

      const selected_section = vm.section_operation.section
      const prev_step = vm.section_operation.step

      vm.section_operation.loading = true

      if (vm.section_operation.sync_fail) {
        vm.section_operation.sync_fail = false
      }

      try {
        let update_section_id = null
        let update_group_section_id = null
        if (vm.isEmpty(selected_section.section)) {
          vm.section_operation.step = 'preparing_class'
        }

        const { data: groupResponse } = await vm.$axios.post(GROUP.GET_DETAIL_BY_CLASS_ID(selected_section.id_kls));

        if (groupResponse.applicationSystem.code != 0) {
          vm.section_operation.sync_fail = true
          vm.section_operation.step = prev_step
          vm.section_operation.loading = false
          return
        } else {
          const sectionLists = groupResponse.data.sections;

          const newSection = collect(sectionLists)
            .where('meet', parseInt(selected_section.meet))
            .where('scheduleId', selected_section.id_perkuliahan)
            .first()

          update_section_id = newSection.id
          update_group_section_id = newSection.groupId
        }

        if (prev_step === 'confirm_start') {
          const { data: updateSection } = await vm.$axios.post(SECTION.UPDATE(update_section_id), {
            progress: 'B',
            real_started_at: selected_section.realStartedAt ?? moment().format('YYYY-MM-DD HH:mm:ss'),
          })

          if (updateSection.applicationSystem.code == 0) {
            vm.section_operation.step = 'start_success'
            this.getWeekSchedules()
            this.trackStartSection();
          } else {
            vm.closeSectionModal()
            toast.danger(updateSection.applicationSystem.message)
          }
        } else if (prev_step === 'confirm_finish') {
          vm.closeSectionModal()
          vm.$router.push(`/panel/classes/${update_group_section_id}/sections/${update_section_id}/planoutcome`)
        } else if (prev_step === 'presence') {
          vm.closeSectionModal()
          vm.$router.push(`/panel/classes/${update_group_section_id}/sections/${update_section_id}/presence`)
        } else {
          // do nothing
        }

        vm.section_operation.loading = false
      } catch (error) {
        toast.danger('Terjadi kendala di sistem. Silahkan ulangi kembali')
        vm.section_operation.loading = false
      }
    },
  }
}
</script>

<style scoped lang="scss">
.week-schedule-grid {
  padding: 3px;
}

.week-schedule-button {
  border-radius: 50%;
}

.schedule-date {
  margin-top: 4px;
  margin-bottom: -11px;
}

.schedule-exist {
  font-size: 6px;
}

.schedule-divider {
  margin: 25px 10px 5px;
  border-top: .1rem solid #E2E7FF;
}
</style>
